import React from 'react'
import { Link } from 'react-router-dom'
import HR from '../images/hr.svg'
import { FaCloud, FaLock, FaMobileAlt, FaDesktop } from 'react-icons/fa';
import SubserviceDetailComponent from '../components/SubserviceDetailComponent';

const services = [
    {
      icon: <FaCloud />,
      title: 'Conflict Resolution',
      description: 'Address and resolve workplace conflicts effectively, maintaining a positive and productive work environment.',
    },
    {
      icon: <FaLock />,
      title: 'Employee Engagement',
      description: 'Implement strategies to enhance employee engagement and satisfaction, fostering a motivated workforce.',
    },
    {
      icon: <FaMobileAlt />,
      title: 'Workplace Diversity & Inclusion',
      description: 'Promote diversity and inclusion within your workplace, creating a respectful and equitable environment for all employees.',
    },
  
  ];

const  EmployeeRelations = () => {
  return (
    <div>
       <div className = "relative">
      <img
        className="h-auto w-full object-cover"
        src={HR}
        alt="HR Services"
      />

      <div>

      <section className='text-left mt-6'>
      <h1 className="text-center my-6 text-2xl font-semibold">Employee Relations & Workplace Culture</h1>
      </section>
     

      <section>
        <SubserviceDetailComponent services={services}/>
        <div className='mb-6'>
      <h2 className="text-xl font-semibold mb-6 mx-6">Get Started with Expert HR Services</h2>
      <p className="text-md text-black mb-6 px-12 text-left">
      Maximize efficiency, enhance security, and drive growth with our tailored HR Services. Our certified experts provide 24/7 support, proactive monitoring, and strategic HR planning to meet your business needs.
      </p>
      
      <Link to="/contact"
        className="inline-block bg-[#13689b] text-white py-3 px-6 rounded-md text-md font-semibold transition-transform transform hover:scale-105">
      Contact Us
      </Link>
     
      </div>
      </section>

    </div>

    </div>
    </div>
  )
}

export default EmployeeRelations
